import React, { useState, useEffect } from 'react';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  height: 64,
  padding: '20px 16px',
  border: '1px solid rgba(250,253,251,0.16)',
  borderRadius: 16,
  fontSize: 16,
  fontWeight: 400,
  boxSizing: 'border-box',
  background: 'rgba(250,253,251,0.08)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  color: '#FAFDFB',
  fontFamily: "'Figtree', sans-serif",
  transition: 'all 0.2s ease',
  outline: 'none',
};

const NameStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  const parts = (answer || '').split(/\s+/);
  const [first, setFirst] = useState(parts[0] || '');
  const [last, setLast] = useState(parts.slice(1).join(' ') || '');

  useEffect(() => {
    if (answer) {
      const p = answer.split(/\s+/);
      setFirst(p[0] || '');
      setLast(p.slice(1).join(' ') || '');
    }
  }, [answer]);

  const capitalize = (s: string) =>
    s.charAt(0).toUpperCase() + s.slice(1);

  const handleChange = (f: string, l: string) => {
    const combined = `${f} ${l}`.trim();
    if (f.trim() && l.trim()) {
      onAnswer(combined);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <input
        type="text"
        placeholder="First name"
        value={first}
        onChange={(e) => { const v = capitalize(e.target.value.replace(/\s/g, '')); setFirst(v); handleChange(v, last); }}
        style={inputStyle}
        autoFocus
      />
      <input
        type="text"
        placeholder="Last name"
        value={last}
        onChange={(e) => { const v = capitalize(e.target.value.replace(/\s/g, '')); setLast(v); handleChange(first, v); }}
        style={inputStyle}
      />
    </div>
  );
};

export default NameStep;
